<template>
  <section class="container py-5">
    <div class="row align-items-center">
      <div class="col-md-6 mb-4 mb-md-0">
        <img
          src="@/assets/images/porque-frenkel.png"
          alt="Why Frenkel"
          class="img-fluid rounded shadow-sm"
        />
      </div>

      <div class="col-md-6 underline-hover">
        <h2 class="fw-bold mb-3">
          {{ content[selectedLang]?.title }}
        </h2>
        <p class="text-justify">
          {{ content[selectedLang]?.text1 }}
        </p>
        <p class="text-justify">
          {{ content[selectedLang]?.text2 }}
        </p>
        <blockquote class="fst-italic text-muted mt-3">
          {{ content[selectedLang]?.quote }}
        </blockquote>
      </div>
    </div>
  </section>
</template>

<script>
import { defineComponent } from 'vue';
import { whyFrenkel as content } from '@/assets/data/data.ts';

export default defineComponent({
  name: 'WhyFrenkel',
  props: {
    selectedLang: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      content
    };
  }
});
</script>

<style scoped>
.text-justify {
  text-align: justify;
}
.img-fluid {
  transition: transform 0.4s ease, box-shadow 0.4s ease;
}

.img-fluid:hover {
  transform: scale(1.05);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

.underline-hover {
  position: relative;
  display: inline-block;
  cursor: default;
  transition: color 0.3s ease;
}

.underline-hover::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  height: 2px;
  width: 0%;
  background-color: currentColor;
  transition: width 0.3s ease;
  opacity: 0;
}

.underline-hover:hover::after {
  width: 100%;
  opacity: 0.4;
}
</style>
